import React from "react";
import "./AboutUs.css";

const AboutUs = () => {
  return (
    <div className="aboutus" id="aboutus">
      <div className="aboutus__title">
        <h2>who we are</h2>
        <hr />
      </div>
      <div className="aboutus__details">
        <p className="define">
          We are one of Klaviyo’s most skilled partners in the area of customer retention, 
          email marketing campaigns, dynamic flows, advance segmentation, upsell/cross-sell, 
          and conversion optimisation.
        </p>
        <p className="description">
          As Klaviyo Master Partners, we specialise in designing, developing, and fine-tuning Klaviyo 
          email marketing systems. We deliver results by creating eCommerce email automation strategies 
          in Klaviyo specifically tailored for our clients' needs. Our direct connection with Klaviyo as 
          one of the first UK based Klaviyo Master Partners allows us to work on cutting-edge campaigns 
          that will  increase your customer communications with intelligent marketing automation, from 
          the welcome email right through to abandoned baskets and post-purchase.
        </p>
      </div>
    </div>
  );
};

export default AboutUs;
